var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplorer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8315)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8315",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9029 12.8252C17.9775 14.9112 17.0146 17.4785 16.6939 20.2062H33.7021V18.9225C33.5417 17.1575 33.2207 15.3925 32.258 13.7879C30.9743 11.702 28.8889 10.579 26.4817 10.258C22.9518 9.61626 19.5821 10.258 16.3731 11.5417C11.5595 13.3067 7.54814 16.1949 4.33896 20.0459C3.85762 20.6876 3.37627 21.4899 2.73438 22.2919C2.73438 21.8106 2.73438 21.6502 2.89473 21.3293C3.53643 16.8371 5.14082 12.5043 8.18975 8.97417C11.7199 4.80256 16.2128 2.23537 21.6686 1.27261C26.9635 0.470267 31.9377 1.27261 36.5909 4.00025C40.9228 6.40718 43.811 10.0976 45.5761 14.7507C46.5388 17.318 47.0201 20.2063 47.1807 22.9343V28.8711H17.0146C17.0146 31.278 17.817 33.5243 19.4216 35.2893C21.347 37.3753 23.9138 38.3379 26.4815 38.8193C32.2579 39.6216 37.553 38.6589 42.5271 35.7707C42.6487 35.7538 42.7615 35.6975 42.848 35.6103H43.0084V45.2376C43.0084 45.5586 42.848 45.7189 42.5271 45.8793C38.9971 47.6443 35.1461 48.7675 31.1348 48.9279C28.5675 49.0882 26.0002 49.0882 23.5935 48.6069C16.0525 47.0019 9.95508 41.5466 8.51103 33.6841C6.90645 24.6986 11.2389 16.5154 19.7429 12.8251C19.7426 12.8252 19.7426 12.8252 19.9029 12.8252Z",
    fill: "#26A6D1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorer);
export default __webpack_public_path__ + "static/media/Explorer.cd6231fcd1ce082b0d088b56f2db0b65.svg";
export { ForwardRef as ReactComponent };